import { o, lensPath as path, lensProp as prop, lensIndex as index } from 'ramda'

// primitives
export const id$ = prop('id')
export const value$ = prop('value')
export const stayInfo$ = prop('stayInfo')
export const quantity$ = prop('quantity')
export const roomStays$ = prop('roomStays')
export const adultCount$ = prop('adultCount')
export const childCount$ = prop('childCount')
export const nightCount$ = prop('nightCount')
export const orderItems$ = prop('orderItems')
export const reservation$ = prop('reservation')
export const currencyCode$ = prop('currencyCode')
export const hotelBooking$ = prop('hotelBooking')
export const cancellationInfo$ = prop('cancellationInfo')
export const cancellationNumber$ = prop('cancellationNumber')
export const netPriceIncludingTaxes$ = prop('netPriceIncludingTaxes')

// composites (can only be applied to a single OrderItem)
// an Order object has many OrderItems
export const reservation$$ = o(hotelBooking$, reservation$)
export const roomStays$$ = o(reservation$$, roomStays$)
export const stayInfo$$ = o(reservation$$, stayInfo$)
export const adultCount$$ = o(stayInfo$$, adultCount$)
export const childCount$$ = o(stayInfo$$, childCount$)
export const nightCount$$ = o(stayInfo$$, nightCount$)

// finals (can be used directly on an Order object)
// only zoom on the first orderItem of said Order // !important
export const id = id$
export const metaInfo = prop('metaInfo')
export const totalOrderPrice = o(metaInfo, prop('totalOrderPrice'))
export const currencyCode = o(totalOrderPrice, currencyCode$)
export const orderItems = orderItems$
export const firstOrderItem = o(orderItems$, index(0)) // !important
export const hotelBooking = o(firstOrderItem, hotelBooking$)

export const status = o(hotelBooking, prop('status'))
export const hotel = o(hotelBooking, prop('hotel'))
export const hotelId = o(hotel, id$)
export const hotelName = o(hotel, prop('name'))
export const contact = o(hotel, prop('contact'))
export const medias = o(hotel, path(['media', 'medias']))
export const cancellationInfo = o(hotelBooking, cancellationInfo$)
export const cancellationNumber = o(cancellationInfo, cancellationNumber$)

export const hotelRating = o(hotel, prop('rating'))
export const hotelStars = o(hotelRating, path(['star', 'score']))

export const reservation = o(hotelBooking, reservation$)
export const stayInfo = o(reservation, prop('stayInfo'))
export const welcomeInfo = o(reservation, prop('welcomeInfo'))
export const welcomeUrl = o(welcomeInfo, prop('welcomeUrl'))
export const checkinStatus = o(welcomeInfo, prop('checkinStatus'))
export const arrivalDate = o(stayInfo, prop('arrivalDate'))
export const departureDate = o(stayInfo, prop('departureDate'))
export const nightCount = o(stayInfo, nightCount$)

export const loyaltySimulationPoints = o(hotelBooking, prop('loyaltySimulationPoints'))
export const amounts = o(reservation, prop('amounts'))
export const prepayableAmount = o(amounts, prop('prepayableAmount'))
export const prepayableCurrency = o(prepayableAmount, currencyCode$)
export const prepayableValue = o(prepayableAmount, value$)
export const prepaidAmount = o(amounts, prop('prepaidAmount'))
export const prepaidCurrency = o(prepaidAmount, currencyCode$)
export const prepaidValue = o(prepaidAmount, value$)

export const loyaltyProgram = o(hotel, prop('loyaltyProgram'))
export const earnAllowed = o(loyaltyProgram, prop('earnAllowed'))

export const loyaltyInfo = o(metaInfo, prop('loyaltyInfo'))
export const simulation = o(loyaltyInfo, prop('simulation'))
export const isHotelParticipating = o(loyaltyInfo, prop('isHotelParticipating'))
export const aberrantes = o(simulation, prop('aberrantes'))
export const totalRewardsPoints = o(simulation, prop('totalRewardsPoints'))
export const totalStatusPoints = o(simulation, prop('totalStatusPoints'))
